import React, { useEffect, useRef } from "react";

const VideoSlide = ({
    item,
    isActive,
}: {
    item: StandbyScreenItemType;
    isActive: boolean;
}): JSX.Element => {
    const videoRef = useRef<HTMLVideoElement>(null);

    // Preload the video once when mounted
    React.useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        // Enable preloading
        video.preload = "auto";
        // Start buffering
        video.load();
    }, [item.content]);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const playVideo = async () => {
            if (isActive) {
                try {
                    // Wait until enough data is buffered to play through
                    if (video.readyState < 4) {
                        // 4 = HAVE_ENOUGH_DATA
                        await new Promise((resolve) => {
                            video.addEventListener("canplaythrough", resolve, {
                                once: true,
                            });
                        });
                    }
                    // Reset to beginning
                    video.currentTime = 0;
                    await video.play();
                } catch (error) {
                    if (error instanceof Error && error.name !== "AbortError") {
                        console.error("Video play failed:", error);
                    }
                }
            } else {
                // Pause when inactive
                video.pause();
                video.currentTime = 0;
            }
        };

        playVideo();

        return () => {
            if (video) {
                video.pause();
                video.currentTime = 0;
            }
        };
    }, [isActive]);

    return (
        <video
            ref={videoRef}
            muted
            playsInline
            loop
            className="h-100 w-100"
            style={{
                objectFit: "fill",
            }}
        >
            <source src={item.content} type="video/mp4" />
        </video>
    );
};

export default VideoSlide;
